import groq from "groq";
import { localisedField } from "../../groq-utils/localisedField";
export const ctaFields = groq`
    "title":  ${localisedField("title")},
    "url":  ${localisedField("url")}
`;
